import React, { useEffect, useRef } from "react";
import { useIsServer } from "../../../../hooks";
export const TrustPilotMiniBanner = ({ locale = "en", theme = "light", className = "", }) => {
    const containerRef = useRef(null);
    const isServer = useIsServer();
    useEffect(() => {
        if (isServer || !containerRef.current) {
            return;
        }
        try {
            const script = document.createElement("script");
            script.src =
                "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
            script.async = true;
            script.onerror = () => {
                console.warn("Failed to load TrustPilot script");
            };
            containerRef.current.appendChild(script);
        }
        catch (error) {
            console.error("Error loading TrustPilot widget:", error);
        }
    }, [isServer]);
    return (React.createElement("div", { ref: containerRef, className: className }, !isServer && React.createElement("div", { className: "trustpilot-widget", "data-theme": theme, "data-font-family": "Figtree", "data-locale": locale, "data-template-id": "5419b637fa0340045cd0c936", "data-businessunit-id": "597f015c0000ff0005a7cd72", "data-style-height": "20px", "data-style-width": "100%" },
        React.createElement("a", { href: "https://uk.trustpilot.com/review/www.thinkmarkets.com", target: "_blank", rel: "noopener noreferrer" }, "Trustpilot"))));
};
